/* eslint-disable no-undefined */
import { Stack, TextInput } from "@wearewqa/wqa-design-system";
import React from "react";

interface SignInFormInputsProps {
  formData: { email: string; password: string };
  onInputChange: (key: string, value: string) => void;
  hasError: boolean;
}

export function SignInFormInputs({
  formData,
  onInputChange,
  hasError,
}: SignInFormInputsProps) {
  return (
    <Stack>
      <TextInput
        required
        id={"signinform_email"}
        label={"Email"}
        type="email"
        value={formData.email}
        placeholder="Enter your email"
        onChange={(e) => onInputChange("email", e.target.value)}
        error={hasError ? " " : undefined}
      />

      <TextInput
        required
        id={"signinform_password"}
        label={"Password"}
        type="password"
        value={formData.password}
        onChange={(e) => onInputChange("password", e.target.value)}
        error={hasError ? "Your email or password is incorrect" : undefined}
      />
    </Stack>
  );
}
